import Cookie from "js-cookie";

export default {
    data: {
        id: null,
        fields: {
            last_name: '',
            last_name_title: ' ',
            first_name: '',
            phone: '',
            email: '',
            suggestion: '',
            notice_checked: false
        },
        files: {
            local: [],
            gdrive: [],
            dropbox: []
        },
        credentials: {
            gdrive: {
                api_key: "AIzaSyAh3x-g7mYSRjD1rsFQNZeaof4XnT8yOpQ",
                client_id: "704397145095-0suvejgepdhfapjtpnnn2uvvbccn3kk0.apps.googleusercontent.com",
                access_token: null,
            },
        }
    },
    errors: {
        zh: {
            custom: {
                prefix: {
                    required: '請輸入稱謂'
                },
                last_name: {
                    required: '請輸入姓氏'
                },
                first_name: {
                    required: '請輸入名字'
                },
                phone: {
                    tel: '請輸入聯絡電話',
                    required: '請輸入聯絡電話'
                },
                email: {
                    email: '請輸入電郵地址',
                    required: '請輸入電郵地址',
                },
                terms: {
                    required: '請點擊確認聲明'
                },
                files: {
                    required: '請上載履歷',
                    size: '上載履歷超過10MB上限',
                    minSize: '上載履歷須大於1KB',
                    max: '上載文件上限: 4',
                    type: '可上傳的文件格式: MS Word, MS Excel, PDF, JPG, PNG 及TXT'
                }
            },
        },
        en: {
            custom: {
                prefix: {
                    required: 'Prefix is required. '
                },
                last_name: {
                    required: 'Surname is required.'
                },
                first_name: {
                    required: 'Given name is required.'
                },
                phone: {
                    tel: 'Enter a valid contact number.',
                    required: 'Contact number is required.'
                },
                email: {
                    email: 'Enter a valid email address.',
                    required: 'Enter a valid email address.'
                },
                terms: {
                    required: 'Please click the appropriate box.'
                },
                files: {
                    required: 'Please upload your CV.',
                    size: 'Uploaded file size is over 10MB.',
                    minSize: 'Uploaded file size must be at least 1KB.',
                    max: 'Max no. of attachment: 4',
                    type: 'Uploaded file format: MS Word, MS Excel, PDF, JPG, PNG and TXT'
                }
            },
        },
    },

    firstVisit: false,
    validated: false,
    cookie() {
        if (this.firstVisit)
            this.save();
        else
            this.restore();
    },
    save() {
        const in30minutes = 1/48;
        Cookie.set(
            'FormDataStore.data.fields',
            JSON.stringify(this.data.fields),
            {expires: in30minutes}
        );
    },
    restore() {
        const json = Cookie.get('FormDataStore.data.fields');
        if (json) {
            this.data.fields = JSON.parse(json);
        }
        this.firstVisit = true;
    },
    clear() {
        this.validated = false;
        Object.keys(this.data.fields).map(key => {
            this.data.fields[key] = '';
        });
        this.data.fields.notice_checked = false;
        this.data.id = null;
        Object.keys(this.data.files).map(key => {
            this.data.files[key] = [];
        });
        Cookie.remove('FormDataStore.data.fields');
    },
}
